import { useEffect, useState } from "react";

import { getToken } from "@/utils/tokenStorage";

/**
 * Natureza contábil da classificação — obrigatória desde 25/08/2026.
 *
 * É ela que decide em qual linha do DRE a despesa entra. Sem natureza a despesa
 * não aparece em linha nenhuma do relatório, então o campo é exigido na criação
 * em vez de "opcional que a gente resolve depois".
 *
 * A lista vem do backend (`/expense-classifications/naturezas`) de propósito:
 * duplicá-la aqui garantiria que um dia as duas saiam de sincronia.
 */
export default function SeletorNatureza({ valor, onChange, compacto = false }) {
  const [opcoes, setOpcoes] = useState([]);

  useEffect(() => {
    const token = getToken();
    fetch("/api/expense-classifications/naturezas", {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => d?.naturezas && setOpcoes(d.naturezas))
      .catch(() => setOpcoes([]));
  }, []);

  const atual = opcoes.find((o) => o.id === valor);

  return (
    <div className={compacto ? "flex-1 min-w-[160px]" : "space-y-1.5"}>
      {!compacto && (
        <label className="text-sm font-medium">
          Natureza <span className="text-red-500">*</span>
        </label>
      )}
      <select
        value={valor || ""}
        onChange={(e) => onChange(e.target.value)}
        className={`w-full rounded-md border border-input bg-background px-3 text-sm ${
          compacto ? "h-8" : "h-10"
        }`}
      >
        <option value="">
          {compacto ? "Natureza…" : "Selecione a natureza contábil"}
        </option>
        {opcoes.map((o) => (
          <option key={o.id} value={o.id}>
            {o.label}
          </option>
        ))}
      </select>
      {!compacto && (
        <p className="text-xs text-muted-foreground">
          {atual?.ajuda ||
            "Define em qual linha do DRE esta despesa entra."}
        </p>
      )}
    </div>
  );
}
